import { DSStatus, Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveDesignSubmittalMutation } from 'schema'
import { DesignSubmittal } from '../../../../DesignSubmittalLogContext/types'

export function useRemoveOptions(): RemoveRowActionOptions<DesignSubmittal> {
  const { refetch } = useDesignSubmittalLogContext()
  const [remove] = useSoftRemoveDesignSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveDesignSubmittal: {
        designSubmittal: { sharePointFolderName },
      },
    }) => {
      simpleRemoveNotification(sharePointFolderName)
    },
  })
  return {
    permission: Permission.RemoveRestoreDesignSubmittal,
    disabled: ({ statusId }) =>
      statusId === DSStatus.ReturnedToDesignBuilder.id ||
      statusId === DSStatus.Unlocked.id
        ? {
            message: `Cannot be removed while in status: ${
              DSStatus.fromIdOrFail(statusId).name
            }`,
          }
        : false,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      await refetch()
    },
  }
}
